import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import MaterialGroup from '../../types/api/material-group'

export const materialGroupsApi = createApi({
    reducerPath: 'materialGroupsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['MaterialGroups'],
    endpoints: builder => ({
        getMaterialGroups: builder.query<Strapi<MaterialGroup>, EndpointQueryParameters | void>({
            query: getQuery('/material-groups'),
        }),
    }),
})

export const { useGetMaterialGroupsQuery } = materialGroupsApi
